import useTranslation from 'next-translate/useTranslation'

import useAppSelector from '../../../../store/hooks/useAppSelector'
import {
  checkoutCapacityConflictAllocationSelector,
  checkoutCapacityConflictRequestedTimeSelector,
  checkoutCapacityConflictHasTimesSelector,
  checkoutCapacityConflictSingleSelector,
} from '../../store/checkoutSelectors'
import { CapacityConflictAdjustVerb } from '../../types'
import getCapacityConflictRequestedTimeLabel from '../../utils/getCapacityConflictRequestedTimeLabel'
import useCapacityConflictActions from '../../hooks/useCapacityConflictActions'

import CapacityConflictItemsList from './CapacityConflictItemsList'
import CapacityConflictFooter from './CapacityConflictFooter'
import CapacityConflictStepDescription from './CapacityConflictStepDescription'

const PrimaryLabelKeys: Record<CapacityConflictAdjustVerb, string> = {
  [CapacityConflictAdjustVerb.Remove]:
    'checkoutCapacityConflict.removeAndContinueButton',
  [CapacityConflictAdjustVerb.Update]:
    'checkoutCapacityConflict.updateAndContinueButton',
}

export default function CapacityConflictAdjustOrderStep() {
  const { t } = useTranslation('common')

  const single = useAppSelector(checkoutCapacityConflictSingleSelector)
  const hasTimes = useAppSelector(checkoutCapacityConflictHasTimesSelector)
  const allocation = useAppSelector(checkoutCapacityConflictAllocationSelector)
  const { isPending, applyAdjustment, chooseAnotherDay, cancel } =
    useCapacityConflictActions()
  const requestedTime = useAppSelector(
    checkoutCapacityConflictRequestedTimeSelector,
  )

  if (!allocation) {
    return null
  }

  const formattedRequestedTime = getCapacityConflictRequestedTimeLabel(
    requestedTime,
    t,
  )

  function handleClose() {
    cancel()
  }

  function handleChooseAnotherDay() {
    chooseAnotherDay()
  }

  function handleAdjustAndContinue() {
    applyAdjustment()
  }

  return (
    <>
      <CapacityConflictStepDescription>
        {single
          ? t('checkoutCapacityConflict.adjustStepSingleMessage', {
              time: formattedRequestedTime,
            })
          : t('checkoutCapacityConflict.adjustStepMessage', {
              time: formattedRequestedTime,
            })}
      </CapacityConflictStepDescription>
      <CapacityConflictItemsList />
      <CapacityConflictFooter
        secondaryLabel={
          hasTimes
            ? t('checkoutCapacityConflict.cancelButton')
            : t('checkoutCapacityConflict.chooseAnotherDayButton')
        }
        onSecondaryClick={hasTimes ? handleClose : handleChooseAnotherDay}
        primaryLabel={t(PrimaryLabelKeys[allocation.verb])}
        onPrimaryClick={handleAdjustAndContinue}
        primaryDisabled={isPending}
      />
    </>
  )
}
